// Saga-only buy-box behavior: power add-on card selection (cosmetic, no price
// effect) and bundle-row selection (recomputes the Totaal row and sets
// window.sagaBundleReplaceItem for product-cart.js to swap into the add-to-
// cart request — every non-"this product" row is a full alternative, never
// an add-on alongside Saga).
(function () {
  if (window.sagaBuyboxInit) return;
  window.sagaBuyboxInit = true;

  function formatMoney(cents) {
    // No-space "€4.725,00" format, matching the Liquid-rendered
    // `€{{ x | money_without_currency }}` output exactly (an Intl
    // currency formatter would insert a space after "€" in nl-NL locale).
    try {
      return '€' + (cents / 100).toLocaleString('nl-NL', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    } catch (e) {
      return '€' + (cents / 100).toFixed(2).replace('.', ',');
    }
  }

  // Power add-on: each card maps to an add-to-cart quantity of this product
  // (1 stack = 1 unit). Selecting a card writes that quantity into the hidden
  // `quantity` inputs bound to the main and sticky product forms, so switching
  // back to a lower stack count lowers the quantity again — the value is always
  // set from the chosen card, never incremented.
  function applyPowerAddonQuantity(qty) {
    // Update every quantity field belonging to an add-to-cart form, not just
    // our own hidden ones. If a template also renders a visible quantity
    // selector, that form would carry two `quantity` fields and post both —
    // writing the same value to all of them makes it irrelevant which one the
    // cart honours. Association is read from `input.form`, so inputs bound via
    // the `form` attribute are matched even though they sit outside the form,
    // and cart-page quantity inputs are excluded.
    var inputs = document.querySelectorAll('input[name="quantity"]');
    inputs.forEach(function (input) {
      var form = input.form;
      if (!form || form.getAttribute('data-type') !== 'add-to-cart-form') return;
      if (input.value === String(qty)) return;
      input.value = qty;
      // A visible selector binds through Alpine's x-model; without these the
      // component's own state would overwrite the value we just set.
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    // Kept readable for the bundle/total logic and anything added later.
    window.sagaPowerAddonQuantity = qty;
  }

  // The quantity that will actually be posted, read back off the form rather
  // than from our own tracked value, so the Totaal box can never disagree with
  // what the cart is about to charge. Association is read from `input.form`
  // for the same reason as in applyPowerAddonQuantity: an input bound through
  // the `form` attribute still counts, a cart-page input doesn't.
  function cartQuantity() {
    var found = 0;
    document.querySelectorAll('input[name="quantity"]').forEach(function (input) {
      if (found) return;
      var form = input.form;
      if (!form || form.getAttribute('data-type') !== 'add-to-cart-form') return;
      var n = parseInt(input.value, 10);
      if (n > 0) found = n;
    });
    if (found) return found;
    // No quantity field on this template — fall back to the power add-on's own
    // value, then to a single unit.
    var tracked = parseInt(window.sagaPowerAddonQuantity, 10);
    return tracked > 0 ? tracked : 1;
  }

  function selectPowerCard(grid, card) {
    grid.querySelectorAll('.saga-power-card').forEach(function (c) {
      var selected = c === card;
      c.setAttribute('data-selected', selected ? 'true' : 'false');
      c.setAttribute('aria-pressed', selected ? 'true' : 'false');
      c.style.border = selected ? '2px solid #282928' : '1px solid #e3e3df';
    });
    var qty = parseInt(card.getAttribute('data-saga-power-qty'), 10);
    applyPowerAddonQuantity(qty > 0 ? qty : 1);
  }

  // Delegated on `document` rather than bound per card: choosing a capacity
  // re-renders the whole buy box through xProductSibling's AJAX swap
  // (innerHTML on .main-product), which fires no section:load event, so direct
  // listeners would be silently dropped and the cards would stop responding.
  function initPowerAddon() {
    if (window.sagaPowerAddonInit) return;
    window.sagaPowerAddonInit = true;

    document.addEventListener('click', function (e) {
      var card = e.target.closest('.saga-power-card');
      if (!card) return;
      var grid = card.closest('[data-saga-power-addon]');
      if (!grid) return;
      selectPowerCard(grid, card);
      // The stack count is a multiplier on whatever row is selected, so the
      // Totaal box has to be recomputed here — picking a card changes the
      // price even though the selected row didn't change.
      refreshBundleTotals();
    });
  }

  // Sync the quantity fields to whichever card is server-rendered as selected,
  // so the posted quantity can't disagree with what's on screen before any
  // click. Safe to re-run after a buy-box swap.
  function syncPowerAddon(grid) {
    var selected = grid.querySelector('.saga-power-card[data-selected="true"]') ||
      grid.querySelector('.saga-power-card');
    if (selected) selectPowerCard(grid, selected);
  }

  // Every node reference here is resolved at call time, never captured at
  // init: choosing a capacity re-renders the whole buy box through
  // xProductSibling's AJAX swap (`destination.innerHTML = source.innerHTML`
  // on .main-product, product-sibling.js), which fires no event of any kind.
  // Anything captured once would be pointing at a detached node afterwards,
  // and anything bound directly to a row node would be gone with it.
  function stickyDefaultTitle(el) {
    // Stored on the element itself rather than in a variable, so a freshly
    // swapped-in node records its OWN server-rendered title the first time we
    // touch it — before a selection can overwrite it — instead of inheriting
    // a default captured from the previous capacity's markup.
    if (typeof el.dataset.sagaDefaultTitle === 'undefined') {
      el.dataset.sagaDefaultTitle = el.textContent;
    }
    return el.dataset.sagaDefaultTitle;
  }

  function applyBundleSelection(container, selectedRow) {
    var totalRow = document.querySelector('[data-saga-total-row]');
    var rows = container.querySelectorAll('.saga-bundle-row');
    var stickyTitleEl = document.querySelector('[data-saga-sticky-title]');
    var defaultStickyTitle = stickyTitleEl ? stickyDefaultTitle(stickyTitleEl) : '';

    rows.forEach(function (row) {
      var selected = row === selectedRow;
      row.setAttribute('data-selected', selected ? 'true' : 'false');
      row.classList.toggle('is-selected', selected);
    });

    // Row 1 (this product) carries no data-replace-item, so selecting it
    // clears the override and add-to-cart behaves normally. Rows 2/3 are
    // always alternatives, never add-ons: product-cart.js swaps the main
    // form's `id` for this item instead of adding it alongside.
    var replaceItem = null;
    var raw = selectedRow.getAttribute('data-replace-item');
    if (raw) {
      try {
        replaceItem = JSON.parse(raw);
      } catch (e) {
        replaceItem = null;
      }
    }
    window.sagaBundleReplaceItem = replaceItem;

    // Row prices are per unit (so the rows stay comparable to each other); the
    // Totaal box and sticky bar are what the customer actually pays, so they
    // scale by the chosen stack count — 2 stacks of a bundle is two of that
    // product in the cart, and this has to show the same figure the cart will.
    var qty = cartQuantity();
    var total = (parseInt(selectedRow.getAttribute('data-price-cents'), 10) || 0) * qty;
    var was = (parseInt(selectedRow.getAttribute('data-compare-cents'), 10) || 0) * qty;

    if (stickyTitleEl) {
      stickyTitleEl.textContent = replaceItem
        ? (selectedRow.getAttribute('data-replace-title') || defaultStickyTitle)
        : defaultStickyTitle;
    }

    // Mirror into the sticky bar: it must show the same total as the Totaal
    // row (the selected row's own price), not the bare Saga variant price
    // the theme renders by default.
    var stickyPrice = document.querySelector('[data-saga-sticky-price]');
    var stickyWas = document.querySelector('[data-saga-sticky-was]');
    if (stickyPrice) stickyPrice.textContent = formatMoney(total);
    if (stickyWas) stickyWas.textContent = was > total ? formatMoney(was) : '';

    if (!totalRow) return;

    var totalEl = totalRow.querySelector('.saga-total-row__total');
    var wasEl = totalRow.querySelector('.saga-total-row__was');
    var savingsEl = totalRow.querySelector('.saga-total-row__savings');

    if (totalEl) totalEl.textContent = formatMoney(total);

    if (was > total && wasEl && savingsEl) {
      wasEl.textContent = formatMoney(was);
      wasEl.style.display = '';
      savingsEl.textContent = 'Je bespaart ' + formatMoney(was - total);
      savingsEl.style.display = '';
    } else {
      if (wasEl) wasEl.style.display = 'none';
      if (savingsEl) savingsEl.style.display = 'none';
    }
  }

  // Re-reads whatever is currently in the DOM and re-applies it. Run on load
  // AND after a capacity swap, which is what keeps window.sagaBundleReplaceItem
  // from surviving into a capacity it doesn't belong to: the swapped-in markup
  // has row 1 selected, so this clears the previous capacity's bundle id
  // instead of leaving it to be posted behind a UI that shows Saga on its own.
  var lastBundleContainer = null;
  function syncBundleTables() {
    // Power add-on first: it establishes the quantity the totals multiply by,
    // so doing it after would leave the Totaal box a step behind.
    document.querySelectorAll('[data-saga-power-addon]').forEach(syncPowerAddon);
    var containers = document.querySelectorAll('[data-saga-bundle-table]');
    containers.forEach(function (container) {
      var rows = container.querySelectorAll('.saga-bundle-row');
      if (!rows.length) return;
      var initial = container.querySelector('.saga-bundle-row[data-selected="true"]') || rows[0];
      applyBundleSelection(container, initial);
    });
    lastBundleContainer = containers[0] || null;
  }

  // Same row stays selected, only the quantity changed — re-run the selection
  // so the Totaal box and sticky bar pick up the new stack count.
  function refreshBundleTotals() {
    document.querySelectorAll('[data-saga-bundle-table]').forEach(function (container) {
      var selected = container.querySelector('.saga-bundle-row[data-selected="true"]');
      if (selected) applyBundleSelection(container, selected);
    });
  }

  function initBundleTable() {
    if (window.sagaBundleTableInit) return;
    window.sagaBundleTableInit = true;

    // Delegated on `document`, like the power add-on and capacity toggle above,
    // so rows that arrive from an AJAX capacity swap are clickable without
    // anything having to rebind them.
    document.addEventListener('click', function (e) {
      var row = e.target.closest('.saga-bundle-row');
      if (!row) return;
      var container = row.closest('[data-saga-bundle-table]');
      if (!container) return;
      applyBundleSelection(container, row);
    });

    // The capacity swap emits no event, so the only reliable signal that the
    // buy box was rebuilt is the DOM itself. Comparing container identity
    // (rather than reacting to any mutation) keeps this from re-entering on
    // the text/attribute writes applyBundleSelection itself makes.
    if (typeof MutationObserver === 'function') {
      var host = document.querySelector('.main-product') || document.body;
      new MutationObserver(function () {
        var current = document.querySelector('[data-saga-bundle-table]');
        if (current === lastBundleContainer) return;
        syncBundleTables();
      }).observe(host, { childList: true, subtree: true });
    }
  }

  // Capacity card "Toon alle samenstellingen" toggle (rows 4-5). Delegated on
  // `document` rather than bound per-button: selecting a capacity re-renders
  // the whole buy box via xProductSibling's AJAX swap
  // (`destination.innerHTML = source.innerHTML` on .main-product), which
  // would silently drop a direct listener on the old button node.
  var CAPACITY_PEEK_HEIGHT = 48; // must match .saga-cc-hidden-wrap height in saga-buybox.css

  function setCapacityExpanded(btn, wrap, expand) {
    var labelEl = btn.querySelector('[data-saga-cc-toggle-label]');
    // Which rows start hidden is decided in Liquid and marked with this
    // attribute, so the peek position lives in exactly one place. Matching on
    // a row index here instead would silently break the moment that changes.
    var lowerRows = wrap.querySelectorAll('[data-saga-cc-collapsed-hidden]');

    if (expand) {
      lowerRows.forEach(function (row) {
        row.removeAttribute('hidden');
      });
      wrap.classList.add('is-expanded');
      var target = wrap.scrollHeight;
      wrap.style.height = CAPACITY_PEEK_HEIGHT + 'px';
      requestAnimationFrame(function () {
        wrap.style.height = target + 'px';
      });
      btn.setAttribute('aria-expanded', 'true');
      if (labelEl) labelEl.textContent = btn.getAttribute('data-label-expanded');
    } else {
      wrap.style.height = wrap.scrollHeight + 'px';
      requestAnimationFrame(function () {
        wrap.style.height = CAPACITY_PEEK_HEIGHT + 'px';
      });
      btn.setAttribute('aria-expanded', 'false');
      if (labelEl) labelEl.textContent = btn.getAttribute('data-label-collapsed');

      var onCollapseEnd = function (e) {
        if (e.propertyName !== 'height') return;
        wrap.removeEventListener('transitionend', onCollapseEnd);
        wrap.classList.remove('is-expanded');
        lowerRows.forEach(function (row) {
          row.setAttribute('hidden', '');
        });
      };
      wrap.addEventListener('transitionend', onCollapseEnd);
    }
  }

  function initCapacityToggle() {
    if (window.sagaCapacityToggleInit) return;
    window.sagaCapacityToggleInit = true;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-saga-cc-toggle]');
      if (!btn) return;
      var wrap = document.getElementById(btn.getAttribute('aria-controls'));
      if (!wrap) return;
      setCapacityExpanded(btn, wrap, btn.getAttribute('aria-expanded') !== 'true');
    });
  }

  // Trustpilot scans the page once on load and initialises every
  // .trustpilot-widget it finds. The sticky bar's Micro Star can miss that pass
  // — it is declared at data-style-width="100%", and a widget measured while
  // its container has no layout box renders nothing and never re-measures. So
  // the widget has to be re-run for that element by hand.
  //
  // THIS USED TO BE A ONE-SHOT RETRY and that is what made the stars appear
  // only sometimes. The old version called loadFromElement once at
  // DOMContentLoaded and once on the first scroll event, both guarded by
  // `if (window.Trustpilot)`. The bootstrap is loaded async from a third-party
  // CDN, so on a cold cache it often had not executed yet at either moment:
  // both attempts no-opped, the scroll listener had already removed itself,
  // and nothing tried again. A refresh "fixed" it only because the script was
  // then HTTP-cached and ready for attempt one. Scroll was also the wrong
  // trigger once the Saga layout started showing the bar from page load — on a
  // visit with no scrolling the single retry never fired at all.
  //
  // So: poll until the widget has actually rendered, rather than guessing when
  // the preconditions are met.
  //  - done()    the widget is live once Trustpilot has injected its iframe.
  //              That, not "we called loadFromElement", is the success signal.
  //  - laidOut() never initialise into a zero-width box; that produces a
  //              rendered-but-invisible widget we would then stop retrying on.
  //  - the 1.5s throttle stops a second call stacking a second iframe while
  //              the first one is still being created.
  //  - ResizeObserver reacts the instant the bar gains a box, so the common
  //              case still resolves immediately rather than on a poll tick.
  // Bounded at ~12s so a genuinely blocked CDN (ad blockers take this script
  // out) stops costing timers instead of polling forever.
  var stickyTpStop = null;

  function initStickyTrustpilot() {
    if (stickyTpStop) stickyTpStop();

    var el = document.querySelector('.saga-sticky__stars .trustpilot-widget');
    if (!el) return;

    var tries = 0;
    var MAX_TRIES = 40;
    var lastCall = 0;
    var timer = null;
    var ro = null;

    function done() {
      return !!el.querySelector('iframe');
    }

    function laidOut() {
      return el.offsetWidth > 0;
    }

    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
      if (ro) { ro.disconnect(); ro = null; }
      stickyTpStop = null;
    }

    function attempt() {
      if (done()) { stop(); return; }
      var now = Date.now();
      if (
        laidOut() &&
        now - lastCall > 1500 &&
        window.Trustpilot &&
        typeof window.Trustpilot.loadFromElement === 'function'
      ) {
        lastCall = now;
        window.Trustpilot.loadFromElement(el, true);
      }
      if (++tries >= MAX_TRIES) stop();
    }

    stickyTpStop = stop;

    if (window.ResizeObserver) {
      ro = new ResizeObserver(attempt);
      ro.observe(el);
    }

    attempt();
    timer = setInterval(attempt, 300);
  }

  // Clicking the header rating scrolls to the Judge.me review widget.
  //
  // Bound here rather than reusing the handler in snippets/review-product.liquid
  // (which already understands [data-scroll-to-reviews]): that snippet only
  // renders where a "rating" block exists, and on this template it does not —
  // the stars in the header come from the saga_header block instead. Today its
  // script happens to reach the page via an unrelated quick-view instance,
  // which is not something to depend on. saga-buybox.js is loaded by the header
  // block itself, so binding here is guaranteed to be present wherever the
  // stars are. The selector is deliberately narrow so the two handlers cannot
  // both fire on the same element.
  function reviewsTarget() {
    var selectors = [
      '#judgeme_product_reviews',
      '.jdgm-widget.jdgm-review-widget',
      '[data-widget-name="review_widget"]',
      '.jdgm-rev-widg'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) return el.closest('.jdgm-widget') || el;
    }
    return null;
  }

  function scrollToReviews() {
    var target = reviewsTarget();
    if (!target) return;
    // The theme publishes its sticky header height as a CSS variable; use it so
    // the widget heading is not left underneath the header.
    var headerVar = getComputedStyle(document.documentElement).getPropertyValue('--height-header');
    var offset = parseFloat(headerVar) || 0;
    var top = window.pageYOffset + target.getBoundingClientRect().top - offset - 12;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: top, behavior: reduced ? 'auto' : 'smooth' });
  }

  function initHeaderRatingLink() {
    if (window.sagaHeaderRatingBound) return;
    window.sagaHeaderRatingBound = true;

    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-saga-reviews-link]')) return;
      e.preventDefault();
      scrollToReviews();
    });
  }

  function init() {
    initPowerAddon();
    initHeaderRatingLink();
    initStickyTrustpilot();
    initBundleTable();
    initCapacityToggle();
    // Reads the current DOM and applies it (bundle rows + power add-on
    // quantity). Also runs itself again after a capacity swap, via the
    // observer set up in initBundleTable.
    syncBundleTables();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
